export interface ServiceSchemaConfig {
	path: string;
	name: string;
	alternateName: string;
	description: string;
	serviceType: string;
}

// Typed Place/Country objects instead of ISO strings: "EU" is not a country
// code, and Norway/Switzerland are listed explicitly because they are not EU members.
export const SERVICE_AREA_SERVED = [
	{ '@type': 'Country', name: 'United States' },
	{ '@type': 'Country', name: 'United Kingdom' },
	{ '@type': 'Place', name: 'European Union' },
	{ '@type': 'Country', name: 'Israel' },
	{ '@type': 'Country', name: 'Norway' },
	{ '@type': 'Country', name: 'Switzerland' }
];

export const SERVICE_AUDIENCE = {
	'@type': 'BusinessAudience',
	audienceType:
		'B2B tech companies: SaaS, wellness, manufacturing, WEB3, miltech, defense, fintech, cybersecurity, enterprise software'
};

// Copy approved by marketing (01.10.2026) — kept in code on purpose: the SEO
// plan (Task 3) forbids duplicating schema texts into CMS fields.
export const SERVICE_SCHEMA_CONFIG: Record<string, ServiceSchemaConfig> = {
	branding: {
		path: '/services/branding',
		name: 'Branding for tech companies',
		alternateName: 'Brand identity for tech companies',
		description:
			'Brand strategy, positioning and visual identity for B2B tech companies. Qream builds scalable brand systems and guidelines for SaaS, fintech, and enterprise teams in competitive categories.',
		serviceType: 'Brand strategy and brand identity'
	},
	websiteProduction: {
		path: '/services/website-production',
		name: 'Web design and development for tech companies',
		alternateName: 'Website design services for tech companies',
		description:
			'Web design and development for B2B tech companies. Qream designs and builds marketing and corporate websites for B2B businesses and enterprise technology brands.',
		serviceType: 'Website design and development'
	},
	creativeMarketingPartnership: {
		path: '/services/creative-marketing-partnership',
		name: 'Creative marketing partnership for tech companies',
		alternateName: 'Graphic design, 3D, animation, and video for tech companies',
		description:
			'Design and creative support for B2B tech companies. Event design, social media content, creative copywriting, presentations, video, and digital ads. Qream became a creative design partner for B2B businesses and enterprise technology brands.',
		serviceType: 'Ongoing marketing retainer'
	}
};
